import request from '@/utils/request'
export function getLAdvertise(type){
    return request({
      url:"/advertise/list",
      params:{type:type,orderByClause:'sort'},
      method:"GET"
    })
}
